import { GetProductsRequest } from '@app-model/request';
import * as CartState from '@app-store/cart/cart.reducer';
import * as UserState from '@app-store/user/user.reducer';
import * as VehicleState from '@app-store/vehicle/vehicle.reducer';

export class SaveQuote {
  VehicleState: VehicleState.State;
  cartState: CartState.State;
  userState: UserState.State;
  getProductRequest: GetProductsRequest;

  constructor(
    getProductsRequest: GetProductsRequest,
    vehicleState: VehicleState.State,
    cartState: CartState.State,
    userState: UserState.State
  ) {
    this.userState = userState;
    this.VehicleState = vehicleState;
    this.cartState = cartState;
    this.getProductRequest = getProductsRequest;
  }
}
